import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaInstagram } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
    const { t } = useTranslation();
    const year = new Date().getFullYear();



    return (
        <motion.footer
            className="relative py-16 border-t border-gray-800/50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
        >
            <div className="absolute inset-0 bg-gradient-to-t from-gray-900/80 to-transparent"></div>

            <div className="responsive-container relative z-10">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
                    <div className="text-center md:text-left">
                        <motion.div
                            className="flex items-center justify-center md:justify-start mb-4"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }}
                        >
                            <span className="text-2xl font-bold text-white">Feres Ben Brahim</span>
                        </motion.div>
                        <motion.p
                            className="text-gray-400 max-w-xs mx-auto md:mx-0"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.1 }}
                        >
                            {t('home.description')}
                        </motion.p>
                    </div>

                    <div className="text-center md:text-right">
                        <motion.h3
                            className="text-white text-lg font-medium mb-4"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }}
                        >
                            {t('footer.connectWithMe')}
                        </motion.h3>
                        <motion.div
                            className="flex justify-center md:justify-end space-x-4"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.1 }}
                        >
                            <motion.a
                                href="https://github.com/feresbr1"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-12 h-12 rounded-full bg-gray-800/50 backdrop-blur-sm flex items-center justify-center text-gray-400 hover:text-white hover:bg-gray-700/50 hover:shadow-lg transition-all duration-300 border border-gray-700/30"
                                whileHover={{ y: -5, scale: 1.1 }}
                                whileTap={{ scale: 0.9 }}
                            >
                                <FaGithub />
                            </motion.a>
                            <motion.a
                                href="https://linkedin.com/in/feres-ben-brahim-08a454216/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-12 h-12 rounded-full bg-gray-800/50 backdrop-blur-sm flex items-center justify-center text-gray-400 hover:text-white hover:bg-gray-700/50 hover:shadow-lg transition-all duration-300 border border-gray-700/30"
                                whileHover={{ y: -5, scale: 1.1 }}
                                whileTap={{ scale: 0.9 }}
                            >
                                <FaLinkedin />
                            </motion.a>
                            <motion.a
                                href="https://instagram.com/feresbr_"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="w-12 h-12 rounded-full bg-gray-800/50 backdrop-blur-sm flex items-center justify-center text-gray-400 hover:text-white hover:bg-gray-700/50 hover:shadow-lg transition-all duration-300 border border-gray-700/30"
                                whileHover={{ y: -5, scale: 1.1 }}
                                whileTap={{ scale: 0.9 }}
                            >
                                <FaInstagram />
                            </motion.a>
                        </motion.div>
                    </div>
                </div>

                <div className="pt-8 border-t border-gray-800">
                    <motion.p
                        className="text-gray-400 text-sm text-center"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                    >
                        {t('footer.copyright').replace('2024', year.toString())}
                    </motion.p>
                </div>
            </div>
        </motion.footer>
    );
};

export default Footer;

